/* eslint-disable */
import React from 'react';
import { GlobalStyles } from '@cimpress/react-components';

export default function App() {
  return (
    <div>
      <GlobalStyles />
      {/*
       * Your app content here
       */}
    </div>
  );
}
